// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"283":"2173fd26","304":"6393691a","497":"769a6a6c","557":"ad1c7ab0","575":"54ea4068"}[chunkId] + ".chunk.js";
};